export const PORTAL_LOGIN = {
  page: 'portal-login-page',
  googleButton: 'portal-google-signin-button',
  nameInput: 'portal-signup-name-input',
  emailInput: 'portal-auth-email-input',
  passwordInput: 'portal-auth-password-input',
  submitButton: 'portal-auth-submit-button',
  toggleModeButton: 'portal-auth-toggle-mode-button',
  errorMessage: 'portal-auth-error-message',
};

export const PORTAL_LAYOUT = {
  sidebar: 'portal-sidebar',
  navOverview: 'portal-nav-overview',
  navAudits: 'portal-nav-audits',
  navApprovals: 'portal-nav-approvals',
  logoutButton: 'portal-logout-button',
};

export const PORTAL_OVERVIEW = {
  page: 'portal-overview-page',
  notLinkedState: 'portal-not-linked-state',
  planName: 'portal-plan-name',
  statusBadge: 'portal-status-badge',
};

export const PORTAL_AUDITS = {
  page: 'portal-audits-page',
  emptyState: 'portal-audits-empty-state',
  table: 'portal-audits-table',
};

export const PORTAL_APPROVALS = {
  page: 'portal-approvals-page',
  emptyState: 'portal-approvals-empty-state',
  approveButton: 'portal-approval-approve-button',
  rejectButton: 'portal-approval-reject-button',
};
